import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1200.000000 1200.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1200.000000) scale(0.100000,-0.100000)">


<path d="M7355 8496 c-53 -23 -105 -103 -105 -161 0 -43 29 -95 84 -154 279
-297 470 -664 550 -1052 135 -656 -51 -1347 -496 -1847 -112 -126 -126 -146
-133 -196 -16 -102 68 -196 175 -196 65 0 100 22 188 115 357 382 581 864 648
1395 23 185 15 543 -15 712 -75 414 -224 760 -466 1083 -106 141 -227 270
-276 295 -44 23 -110 25 -154 6z"/>
<path d="M6510 7953 l-305 -3 -340 -332 -340 -332 -17 -76 c-9 -41 -26 -115
-36 -163 l-20 -88 51 48 c100 94 173 123 308 123 96 0 169 -20 238 -65 48 -32
37 -38 161 82 l75 73 50 -60 c66 -78 130 -204 150 -293 21 -91 21 -244 0 -333
-21 -93 -73 -197 -140 -283 -31 -39 -59 -71 -63 -71 -3 0 -16 10 -27 23 -12
12 -53 53 -92 91 l-72 69 -48 -31 c-73 -46 -132 -62 -232 -62 -135 0 -231 40
-323 137 -40 42 -98 144 -98 174 0 10 -4 19 -8 19 -5 0 -22 -62 -39 -137 l-31
-138 237 -234 c130 -129 328 -325 441 -436 l205 -202 431 -6 431 -6 54 61
c259 294 403 612 450 992 16 134 6 420 -20 546 -63 310 -205 598 -410 834
l-75 86 -120 -2 c-67 -2 -258 -4 -426 -5z m470 -464 c105 -159 168 -312 212
-509 31 -138 31 -423 0 -563 -56 -256 -157 -459 -326 -656 l-69 -80 -128 122
c-71 67 -129 123 -129 125 0 2 25 33 55 69 111 130 189 279 232 441 23 86 26
116 26 262 0 146 -3 176 -26 262 -43 164 -132 329 -241 453 l-45 50 126 126
125 127 66 -72 c36 -39 91 -109 122 -157z"/>
<path d="M3710 6700 l0 -1250 290 0 290 0 0 470 0 470 360 0 360 0 2 -459 3
-459 184 847 c190 873 215 986 301 1375 27 126 50 236 50 243 0 10 -53 13
-270 13 l-270 0 0 -490 0 -490 -360 0 -360 0 0 490 0 490 -290 0 -290 0 0
-1250z"/>
<path d="M5715 7046 c-109 -27 -198 -99 -244 -196 -22 -47 -26 -69 -26 -150 0
-82 4 -103 27 -152 67 -143 243 -232 391 -197 105 24 182 80 239 174 77 125
58 295 -44 410 -54 60 -104 90 -183 111 -60 16 -94 16 -160 0z"/>
<path d="M8525 4536 c-92 -29 -152 -81 -175 -152 -19 -56 -7 -147 25 -195 40
-61 101 -94 234 -125 136 -32 171 -57 171 -119 0 -79 -46 -110 -154 -103 -83
6 -122 23 -177 81 l-41 41 -33 -39 c-63 -74 -64 -80 -21 -124 63 -64 142 -94
263 -99 130 -5 198 14 259 72 105 102 92 294 -26 372 -25 16 -89 39 -170 59
-148 36 -180 56 -180 112 0 22 8 42 24 58 48 48 193 43 262 -10 18 -14 37 -25
42 -25 17 0 84 99 79 114 -8 21 -90 66 -149 82 -65 17 -179 17 -233 0z"/>
<path d="M1420 4125 l0 -415 80 0 80 0 2 188 3 187 185 0 185 0 3 -187 2 -188
80 0 80 0 0 415 0 415 -80 0 -79 0 -3 -157 -3 -158 -185 0 -185 0 -3 158 -3
157 -79 0 -80 0 0 -415z"/>
<path d="M2520 4530 c0 -6 -59 -181 -131 -388 -72 -207 -135 -389 -139 -404
l-9 -28 84 0 84 0 30 93 29 92 160 3 160 2 32 -95 32 -95 84 0 c46 0 84 2 84
4 0 2 -7 23 -16 47 -17 48 -160 462 -227 657 l-42 122 -107 0 c-68 0 -108 -4
-108 -10z m165 -317 c26 -82 50 -154 53 -160 3 -10 -22 -13 -107 -13 -61 0
-111 3 -111 6 0 8 91 297 97 307 12 20 24 -5 68 -140z"/>
<path d="M3140 4125 l0 -415 85 0 85 0 0 180 c0 99 3 180 8 180 4 0 72 -81
152 -180 l145 -180 92 0 c51 0 93 3 93 8 0 4 -33 48 -73 97 -139 172 -257 324
-257 331 0 8 34 51 183 233 64 78 117 147 117 152 0 5 -37 9 -83 9 l-83 0
-139 -170 c-76 -93 -143 -170 -147 -170 -4 0 -8 77 -8 170 l0 170 -85 0 -85 0
0 -415z"/>
<path d="M3910 4125 l0 -415 80 0 80 0 0 415 0 415 -80 0 -80 0 0 -415z"/>
<path d="M4290 4125 l0 -415 75 0 75 0 0 275 c0 151 4 275 8 275 8 0 30 -60
140 -382 l57 -168 70 0 71 0 36 108 c87 260 154 442 161 442 4 0 7 -124 7
-275 l0 -275 75 0 75 0 0 415 0 416 -102 -3 -103 -3 -68 -200 c-110 -324 -139
-405 -147 -405 -4 0 -54 137 -111 305 l-104 305 -107 0 -108 0 0 -415z"/>
<path d="M5360 4126 l0 -416 193 0 c198 0 252 8 332 46 62 29 129 102 156 170
21 52 24 75 24 199 0 133 -1 143 -29 202 -41 89 -113 155 -202 184 -59 19 -98
23 -271 27 l-203 4 0 -416z m385 263 c122 -31 185 -169 155 -341 -17 -95 -44
-138 -111 -171 -48 -24 -68 -28 -155 -30 -54 -1 -100 1 -101 6 -2 4 -3 129 -3
277 l0 270 86 0 c47 0 105 -5 129 -11z"/>
<path d="M6409 4503 c-7 -21 -70 -204 -140 -408 -71 -203 -129 -373 -129 -377
0 -5 37 -8 83 -8 l82 0 29 95 29 95 161 0 162 0 28 -95 29 -95 83 0 c46 0 84
4 84 8 0 4 -15 53 -34 108 -36 105 -207 600 -233 672 l-15 42 -103 0 -103 0
-13 -37z m177 -306 l52 -157 -115 0 c-106 0 -115 1 -108 18 3 9 27 81 53 160
25 78 50 141 56 139 5 -2 33 -74 62 -160z"/>
<path d="M6880 4470 l0 -70 120 0 120 0 0 -345 0 -345 80 0 80 0 0 345 0 345
120 0 120 0 0 70 0 70 -320 0 -320 0 0 -70z"/>
<path d="M7770 4536 c0 -2 -63 -185 -140 -407 -77 -222 -140 -408 -140 -412 0
-4 37 -7 82 -5 l82 3 30 93 30 92 161 0 160 0 29 -95 29 -95 84 0 c45 0 83 4
83 9 0 5 -13 47 -29 93 -16 46 -77 220 -134 388 -58 168 -108 313 -112 323 -6
15 -21 17 -111 17 -57 0 -104 -2 -104 -4z m162 -326 c26 -80 48 -151 48 -160
0 -13 -17 -15 -111 -12 -80 2 -109 7 -106 15 2 7 26 78 53 160 27 81 53 146
58 144 5 -2 31 -68 58 -147z"/>
<path d="M9100 4235 c0 -254 3 -312 16 -352 23 -69 66 -118 132 -150 53 -26
65 -28 182 -28 110 0 131 3 178 24 60 27 122 91 142 148 10 28 15 119 17 351
l4 312 -80 0 -80 0 -3 -297 c-3 -336 -4 -340 -80 -383 -52 -29 -162 -26 -205
6 -60 44 -63 60 -63 382 l0 292 -80 0 -80 0 0 -305z"/>
<path d="M9980 4125 l0 -417 243 4 c227 3 244 4 284 25 164 88 166 335 2 408
-21 10 -39 21 -39 24 0 3 16 19 36 35 20 16 42 44 50 62 29 69 9 169 -43 216
-49 45 -88 52 -315 56 l-218 4 0 -417z m398 270 c44 -32 45 -132 1 -167 -17
-15 -41 -18 -130 -18 l-109 0 0 100 0 100 108 0 c81 0 113 -4 130 -15z m41
-333 c62 -46 61 -164 -2 -202 -27 -17 -51 -20 -154 -20 l-123 0 0 118 c0 65 3
122 8 127 4 4 61 5 126 2 96 -4 124 -9 145 -25z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
